import React, { useEffect } from 'react'
import Box from '@material-ui/core/Box'
import DepositSlipForm from '../../../components/admin/deposit/DepositSlipForm'
import DepositSlipTable from '../../../components/admin/deposit/DepositSlipTable'
import useGDK from '../../../providers/admin/gdk/useGDK'
import { Branch } from '@golden/gdk-admin'

const DepositSlipPage: React.FC = () => {
  const gdk = useGDK()
  useEffect(() => {
    gdk.trunk.trigger([Branch.PLAYER_LAYER])
  }, [gdk])
  return (
    <Box paddingY={5}>
      <Box paddingX={5}>
        <DepositSlipForm />
      </Box>
      <Box paddingTop={3}>
        <DepositSlipTable />
      </Box>
    </Box>
  )
}

export default React.memo(DepositSlipPage)
